module.exports = __webpack_public_path__ + "static/media/delishop_logo2.8270951e.svg";